// Contratos de la API: qué entra y qué sale de cada ruta.
//
// El front tipa su cliente contra esto. Si la API cambia una respuesta, el front
// deja de compilar.
export const API_VERSION = '1';
export const API_PREFIX = `/api/v${API_VERSION}`;
